import React, {FC} from "react"
import {useSelector} from "react-redux"
import isInternOnly from "../selectors/core.selector"

interface InternOnlyProps {
    condition?: boolean
}

const InternOnly: FC<InternOnlyProps> = ({condition, children}) => {
    const internOnly = useSelector(isInternOnly)
    if (condition) {
        // https://stackoverflow.com/a/53689186
        return internOnly ? <>{children}</> : null
    }
    return <>{children}</>
}

InternOnly.defaultProps = {
    condition: true,
}

export default InternOnly
